import _Overlay from './Overlay'
import { withInstall } from '../utils'
import './index.scss'

export const Overlay = withInstall(_Overlay)
export default Overlay
